import { EventCodes } from '../../../App/model/event-codes';

(function () {
	'use strict';

	angular.module('mx.components').component('mxWorkspaceCommonPagingPanel', {
		bindings: {
			preprocessor: '=',
			parameters: '=',
			countonlymode: '=',
		},
		controller: MxWorkspaceCommonPagingPanelCtrl,
		controllerAs: 'vm',
		templateUrl: 'mx-datasource-paging-panel/mx-datasource-paging-panel.html',
	});

	MxWorkspaceCommonPagingPanelCtrl.$inject = ['$scope', 'mx.internationalization', 'mx.shell.EventService'];

	function MxWorkspaceCommonPagingPanelCtrl($scope, i18n, eventService) {
		var vm = this;

		vm.$onInit = function () {
			vm.prev = prev;
			vm.next = next;
			vm.page = page;
			vm.onTotalLoading = onTotalLoading;

			vm.pages = [];

			vm.pagingLabel = '';
			vm.totalLabel = '';

			vm.isNotNextPage = true;
			vm.isNotPrevPage = true;
			vm.isDisabled = false;
			vm.isReloaded = true;

			Object.defineProperty(vm, 'pageSize', {
				get: function () {
					return vm.preprocessor.pageSize;
				},
				set: function (val) {
					if (val && vm.preprocessor.pageSize !== val) {
						vm.preprocessor.page = 1;
						vm.preprocessor.pageSize = parseInt(val);
						vm._callChanged(false);
					}
				},
			});

			var unbindInitPreproc = $scope.$watch('vm.preprocessor', function () {
				if (vm.preprocessor) {
					vm.isNoTotal = !vm.preprocessor.isLocalData;
					vm.preprocessor.callLocalChanges = function (total) {
						vm.preprocessor.count = total;
						return vm._callChanged();
					};
					initPagerLabels();
					initPageLinks();

					unbindInitPreproc();
				}
			});
		};

		$scope.$watch('vm.preprocessor.loading', function (value) {
			if (vm.preprocessor) {
				vm.isDisabled = value;
				if (!value) {
					initPagerLabels();
					initPageLinks();
				}
			}
		});

		$scope.$watch('vm.preprocessor.count', function (newValue, oldValue) {
			if (vm.preprocessor && newValue !== oldValue) {
				initPagerLabels();
				initPageLinks();
			}
		});

		$scope.$watch('vm.parameters.search', function (value, prev) {
			if (vm.preprocessor && value !== undefined && prev !== undefined && value.toString() !== prev.toString()) {
				vm.isNoTotal = true;
			}
		});

		$scope.$watch('vm.preprocessor.page', function (newValue) {
			if (vm.preprocessor) {
				$scope.page = newValue;
			}
		});

		vm._callChanged = function () {
			if (vm.preprocessor) {
				vm.preprocessor.callChanged();
				initPagerLabels();
				initPageLinks();

				if (vm.preprocessor.parameters) {
					//only for page-panel on search has preprocessor.parameters, so it should be tracked only fo search-pages
					eventService.dispatchEvent(EventCodes.TrackTelemetry, {
						eventName: `Page in data list changed`,
						sender: vm.preprocessor.parameters.id,
						senderTitle: vm.preprocessor.parameters.name,
						contextTypeId: vm.preprocessor.parameters.entities.map((entity) => entity.id),
						contextTypeTitle: vm.preprocessor.parameters.entities.map((entity) => entity.name),
					});
				}
			}
		};

		vm._fixPaging = function () {
			// Todo: as backend use page-1 , so vm.preprocessor.page initialised incorrect
			vm.preprocessor.page = vm.preprocessor.page > 0 ? vm.preprocessor.page : vm.preprocessor.page + 1;
		};

		return vm;

		function prev() {
			if (vm.preprocessor.page > 1) {
				vm.preprocessor.page--;
				vm._callChanged();
			}
		}

		function next() {
			vm.preprocessor.page++;
			vm._callChanged();
		}

		function page(pageNumber) {
			if (Number.isInteger(pageNumber)) {
				vm.preprocessor.page = pageNumber;
				vm._callChanged();
			}
		}

		async function onTotalLoading() {
			if (vm.preprocessor && vm.isNoTotal && vm.preprocessor.getDataCount) {
				await vm.preprocessor.getDataCount();

				$scope.$evalAsync(() => {
					vm.isNoTotal = false;

					initPagerLabels();
					initPageLinks();
				});
			}
		}

		function initPageLinks() {
			var from, to, i;

			var startPages = 5;
			vm.pages = [];

			var cnt = vm.preprocessor.count;
			var totalFloat = cnt / vm.preprocessor.pageSize;
			var total = totalFloat % 1 === 0 ? parseInt(totalFloat) : parseInt(totalFloat) + 1;

			// order important
			vm._fixPaging();
			var currentPage = vm.preprocessor.page;

			if (cnt > 0 && total > 0) {
				if (total < startPages) {
					from = 1;
					to = total;
				} else {
					from = currentPage - 2;
					to = from + (startPages - 1);
					if (from < 1) {
						from = 1;
						to = startPages;
					}
					if (to > total) {
						to = total;
						from = to - (startPages - 1);
					}
				}

				if (total >= 6) {
					if (currentPage >= 3) {
						vm.pages.push(1);
						from++;
					}

					// after first separator:  first ... 7 8 9 ... last
					if (currentPage >= startPages - 1) {
						if (currentPage === startPages - 1 || total === 6 || total === 7) {
							from--;
						} else {
							vm.pages.push('...');
						}

						to--;
					}
				}

				if (total >= 7) {
					if (currentPage >= total - 2) {
						from--;
					}
				}

				if (total === 6) {
					if (currentPage >= total - 2) {
						to++;
					}
				} else if (total >= 7) {
					if (total === 7 || currentPage >= total - 3) {
						to++;
					}
				}

				// pages
				for (i = from; i <= to; i++) {
					vm.pages.push(i);
				}

				// before last separator:  first ... 7 8 9 ... last
				if (total >= startPages + 3 && currentPage <= total - 4) {
					vm.pages.push('...');
				}

				// last
				if (total >= startPages + 1 && currentPage <= total - 3) {
					vm.pages.push(total);
				}
			} else {
				vm.pages.push(currentPage);
			}
		}

		function initPagerLabels() {
			vm._fixPaging();

			var cnt = vm.preprocessor.count;
			var pageSize = vm.pageSize || cnt;

			var pageNumber = vm.preprocessor.page;

			vm.isNotPrevPage = pageNumber === 1 || vm.isDisabled;

			var start = (pageNumber - 1) * pageSize + 1;
			var end = start + pageSize - 1;
			if (cnt > 0 && end > cnt) {
				end = cnt;
			}

			vm.pagingLabel = start + ' - ' + end + ' ' + i18n.get('components.mx-datasource-paging-panel.of') + ' ';

			if (cnt > 0) {
				vm.isNotNextPage = end === cnt || vm.isDisabled || vm.preprocessor.disableNext === true;
				vm.isNoTotal = false;
				vm.totalLabel = cnt;
			} else {
				vm.isNotNextPage = cnt !== -1;
				vm.isNoTotal = true;
				vm.totalLabel = i18n.get('components.mx-datasource-paging-panel.many');
			}
		}
	}
})();
